<!-- 赠品活动排列顺序：43整点加赠（进行中）>45权益赠品>42会员加赠>43整点加赠（未开始）>41常规赠品,当前赠品类型有可选时，可选在前 -->
<template>
  <div class="giveaway" v-if="giftData.length">
    <!-- 多个赠品 -->
    <v-list-view name="赠品"  @click="handlePopShow" :class="['g-container', { 'optional-list': optionalList.length }]" right-icon="arrow-right-v3" v-track="[
        { act: 'show', params: { cfrom: '159|002|02|077', event_id: '159|002|02|077', page_name: 1, sku_id: skuId, isno_choose: optionGifts.length ? 1 : 0 } },
        { act: 'click', params: { cfrom: '159|002|01|077', event_id: '159|002|01|077', page_name: 1, sku_id: skuId, isno_choose: optionGifts.length ? 1 : 0 } }]">
      <div class="g-content">
        <div class="g-list">
          <v-scroll-x :data="curGiftList">
            <template v-slot="{ data: item }">
              <div :class="[ item.optionalGiftId ? 'giveaway-optional' : 'giveaway-item', { 'single-item': curGiftList.length == 1 && item.giftFlag == 1 && !item.optionalGiftId },{ 'border-pt': item.vipGiftLevel === 1, 'border-by': item.vipGiftLevel === 2, 'border-hj': item.vipGiftLevel === 3, 'border-zs': item.vipGiftLevel === 4, 'border-zd': item.giftType == 43 || item.giftType == 45//整点加赠和权益赠品共用一套样式
                }, 'border1px', { gray: item.giftType == 43 && !item.hourGiftFlag }]">
                <template >
                   <!-- 整点加赠 -->
                   <template  v-if="item.giftType == 43">
                      <div class="g-top count-down">
                        <div class="zd-bg"></div>
                        <!-- 进行中展示剩余倒计时，未开始隐藏倒计时，待start后刷新 -->
                        <div class="count-time" v-if="currentTime" :aria-label="ariaformate( item.hourGiftFlag == 1, item.hourGiftStartTime, currentTime, item.hourGiftEndTime * 1 )">
                          <v-count-down :start="item.hourGiftStartTime"  :current="currentTime" :end="item.hourGiftEndTime * 1" :endFun="refreshCurGiftList" :startFun="refreshCurGiftList" hiddenHour v-show="item.hourGiftFlag == 1"></v-count-down>
                          <!-- 未开始 -->
                          <p v-if="item.hourGiftFlag != 1">整点加赠</p>
                        </div>
                     </div>
                     <allGiveGiftItem :allGiftItemData="item" :totalGiftLength="curGiftList.length"></allGiveGiftItem>
                   </template>
                  <!-- 权益赠品 -->
                   <template  v-else-if="item.giftType == 45">
                    <!-- 可选赠品 -->
                    <template v-if="item.optionalGiftId">
                      <OptionalGiftItem  :optionalItemData="item.list"></OptionalGiftItem>
                    </template>
                    <!-- 全部赠送 -->
                    <template v-else>
                      <allGiveGiftItem :allGiftItemData="item" :totalGiftLength="curGiftList.length">
                        <template v-slot:specialInfo>
                          <div class="g-top count-down" >
                          <div class="zd-bg"></div>
                          <div class="count-time" aria-label="权益赠品">
                            <p>已购权益</p>
                          </div>
                        </div>
                        </template>
                      </allGiveGiftItem >
                    </template>
                   </template>
                  <!-- 会员加赠 -->
                  <template v-else-if="item.giftType == 42">
                    <!-- 可选赠品 -->
                    <template v-if="item.optionalGiftId">
                      <OptionalGiftItem  :optionalItemData="item.list"></OptionalGiftItem>
                    </template>
                    <!-- 全部赠送 -->
                    <template v-else>
                      <allGiveGiftItem :allGiftItemData="item" :totalGiftLength="curGiftList.length">
                        <template v-slot:specialInfo>
                          <div class="g-top g-vip-pt" v-if="item.vipGiftLevel == 1">
                            <p>会员专享</p>
                          </div>
                          <div class="g-top g-vip-by" v-if="item.vipGiftLevel == 2">
                            <p>白银专享</p>
                          </div>
                          <div class="g-top g-vip-hj" v-else-if="item.vipGiftLevel == 3">
                            <p>黄金专享</p>
                          </div>
                          <div class="g-top g-vip-zs" v-else-if="item.vipGiftLevel == 4">
                            <p>钻石专享</p>
                          </div>
                        </template>
                      </allGiveGiftItem>
                    </template>
                  </template>
                  <!-- 常规赠品及其他 -->
                  <template v-else>
                     <!-- 可选赠品 -->
                     <template v-if="item.optionalGiftId">
                      <OptionalGiftItem  :optionalItemData="item.list"></OptionalGiftItem>
                    </template>
                     <!-- 全部赠送 -->
                     <template v-else>
                      <allGiveGiftItem :allGiftItemData="item" :totalGiftLength="curGiftList.length"></allGiveGiftItem>
                     </template>
                  </template>
                  <div class="single-info" v-if="curGiftList.length == 1 && item.giftFlag == 1 && !item.optionalGiftId">
                    <div class="s-price">
                      <span class="sale-price">￥0</span>
                      <span class="market-price" v-if="item.marketPrice" :aria-label="`原价￥${item.marketPrice}`">
                        ￥{{ item.marketPrice }}
                      </span>
                    </div>
                    <div class="s-name">{{ item.shortName || item.name }}</div>
                  </div>
                </template>
              </div>
            </template>
          </v-scroll-x>
        </div>
        <div class="g-choose" v-if="optionalList.length" aria-label="挑选">挑选</div>
      </div>
    </v-list-view>
   <!-- 赠品弹层 -->
    <v-os-popup
      v-model="isShowPop"
      title="赠品"
      :footerText="buttonNameChange"
      @footerClick="handleClose"
      @close="handleClose"
      :footerShow="isFooterShow"
      container="body"
    >
      <p class="tip">数量有限，赠完即止</p>
      <giftPopContent :curGiftList="curGiftList"  :skuId="skuId" @handleGiftSelect="handleGiftSelect"></giftPopContent>
    </v-os-popup>
  </div>
</template>

<script>
import OptionalGiftItem from './optional-gift'
import allGiveGiftItem from './all-give-gift'
import giftPopContent from './gift-pop-content'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import interval from 'utils/interval'
export default {
  name: 'Giveaway',
  components: {
    OptionalGiftItem,
    allGiveGiftItem,
    giftPopContent
  },
  data() {
    return {
      giftData:[],//赠品原始数据
      isShowPop: false,
      optionGifts:[],//可选赠品集合
      initFlag: true, // 初始化勾选的赠品数据
      tempTime: '' // 当前时间，定时刷新
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo', 'selectedGifts']),
    ...mapGetters('detailv3', ['skuId', 'commodityGifts']),
    // 服务器当前时间
    currentTime: {
      get: function () {
        if (this.tempTime) {
          return this.tempTime
        } else {
          return this.spuInfo?.configInfoVo?.currentTime || ''
        }
      },
      set: function (val) {
        this.tempTime = val
      }
    },
    curGiftList(){//43对整点加赠处理，有进行中的整点加赠则过滤未进行的整点加赠数据，第二场整点加赠排序
      let ongoingHourGifts = [];
      let otherGifts = [];
      this.giftData.forEach(vv => {
        if (vv.giftType == 43 && vv.hourGiftFlag == 1) {
          // 正在进行中的整点加赠
          ongoingHourGifts.push(vv);
        } else if (vv.giftType != 43 || (ongoingHourGifts.length == 0 && vv.hourGiftFlag == 0)) {
          // 不是整点加赠 或者 没有正在进行中的整点加赠
          otherGifts.push(vv);
        }
        // 注意：如果有正在进行中的整点加赠，则hourGiftFlag=0的整点加赠会被忽略
      });
      // 结果是正在进行的整点加赠与其他礼品的组合
      return [...ongoingHourGifts, ...otherGifts];
    },
    // 可选活动列表,父组件数据结构，承接子组件点击事件
    optionalList() {
      return this.optionGiftsChange(this.optionGifts)
    },
    buttonNameChange() {
      return this.optionGifts?.length ? '确定' : '关闭'
    },
    isFooterShow() {
      return !!this.optionGifts?.length
    }
  },
  watch: {
    commodityGifts: {
      handler(newObj) {
       const giftList = newObj
        // giftType 赠品活动类型：41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券,45权益赠品-赠品活动排列顺序：整点加赠（进行中）>权益赠品>会员加赠>整点加赠（未开始）>常规赠品,当前赠品类型有可选时，可选在前
        // giftFlag	赠品标识：1-实物 2-优惠券 3-加赠积分 4-虚拟赠品 5-多倍积分
        // giftCouponType 优惠券显示类型：1-代金券 2-免邮券 3-优惠券
        // vipGiftLevel 会员等级 1：普通 2：白银 3：黄金 4:钻石
        this.optionGifts = []
        this.giftData = []
        if (giftList.length) {
          //处理数据，聚合可选赠品
          const giftListNew = giftList.reduce((result, giftItem) => {
            if (giftItem.optionalGiftId) {//可选赠品聚合
              let group = result.find(item => item.optionalGiftId === giftItem.optionalGiftId);
              if (group) {
                group.list.push(giftItem);
              } else {
                result.push({ "giftType": giftItem.giftType, "optionalGiftId": giftItem.optionalGiftId, "list":[giftItem] });
              }
            } else {//其他赠品结构不变
              result.push(giftItem);
            }
            return result;
          }, []);  
          this.giftData = giftListNew//聚合后的全部赠品数据
          this.optionGifts = giftListNew.filter(giftItem=>giftItem.optionalGiftId).map(opItem=>opItem.list).flat()
        }
        this.initFlag = true
      },
      immediate: true
    },
    giftData: {
      // 监听赠品列表变化，重置列表
      handler(nList, oList) {
        if (nList) {
          this.refreshCurGiftList()
          // 切换skuId时，初始化勾选的赠品数据
          if (this.initFlag) {
            this.initOptionGift()
          }
        }
      },
      immediate: true
    },
    optionGifts: {
      handler() {
        this.updateGiftId()
      },
      deep: true
    }
  },
  mounted() {
    //
  },
  methods: {
    ...mapMutations('detailv3', [
      'UPDATE_GIFT_ID',
      'UPDATE_GIFT_OPT',
      'UPDATE_SELECTED_GIFT_IDS',
      'UPDATE_LAST_CHOOSED_GIFT_IDS'
    ]),
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    ariaformate(flag, startTime, currentTime, endTime) {
      if (flag) {
        if (startTime > currentTime) {
          let time = startTime - currentTime
          let h = parseInt(time / 3600000) % 24
          let m = parseInt(time / 60000) % 60
          return `整点加赠将于${h}小时${m}分钟后开始`
        } else if (endTime > currentTime) {
          let time = endTime - currentTime
          let h = parseInt(time / 3600000) % 24
          let m = parseInt(time / 60000) % 60
          return `整点加赠将于${h}小时${m}分钟后结束`
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    // 刷新整点加赠列表,进行中与未开始的第一场，未开始第二场等待区，待刷新后补位未开始第一场
    refreshCurGiftList() {
      // 刷新当前时间
      if (interval.hasInited) {
        this.currentTime = interval.time
      }
      // giftList为原始返回数据，属性不变，仅重置正在进行中与下一场数据，同一状态可能有多条数据
      this.giftData.forEach((item, index) => {
        if (item.giftType == 43) {
          // 已结束的赠品列表不展示
          if (this.currentTime >item.hourGiftEndTime) {
            this.giftData[index].hourGiftFlag = 2//2代表已结束，前端自定义属性
            this.giftData[index].giftNowTime = this.currentTime
          }
          // 进行中赠品列表
          if (this.currentTime >= item.hourGiftStartTime && this.currentTime < item.hourGiftEndTime) {
            this.giftData[index].hourGiftFlag = 1
            this.giftData[index].giftNowTime = this.currentTime
          }
          // 第一场未开始
          if (this.currentTime < item.hourGiftStartTime) {
            this.giftData[index].giftNowTime = this.currentTime
          }
        }
      })
      this.$forceUpdate()
    },
    initOptionGift() {
      let index = this.selectedGifts.findIndex(item => item.skuId == this.skuId)
      if (index > -1) {
        this.optionGifts.forEach(item => {
          let giftId = item.optionalGiftId + item.id
          if (this.selectedGifts[index].giftsList.includes(giftId)) {
            item.canOptional = 1
          } else {
            item.canOptional = 0
          }
        })
      }
    },
    optionGiftsChange(list) {
      let arr = [...new Set(list.map(v => v.optionalGiftId))]
      let options = []
      arr.forEach(item => {
        let obj = {}
        obj.optionalGiftId = item
        obj.list = list.filter(v => v.optionalGiftId == item)
        options.push(obj)
      })
      return options
    },
    handleGiftSelect(optionalGiftId, selectIdList) {
      this.optionalList
        .find(item => item.optionalGiftId == optionalGiftId)
        .list.forEach(item => {
          if (selectIdList.includes(item.id)) {
            item.canOptional = 1
          } else {
            item.canOptional = 0
          }
        })
    },
    updateGiftId() {
      if (this.optionalList.length) {
        let giftIds = []
        this.optionalList.forEach(item => {
          let arr = item.list.filter(v => v.canOptional == 1).map(v => item.optionalGiftId + v.id)
          giftIds = giftIds.concat(arr.length ? arr : [item.optionalGiftId + 'none'])
        })
        this.UPDATE_GIFT_ID(giftIds.join(','))
      } else {
        this.UPDATE_GIFT_ID('')
      }
    },
    handlePopShow(e) {
      this.savePreFocusElByEvent(e)
      this.isShowPop = true
      // 点击完赠品行后，重置初始化勾选的赠品数据标志位
      this.initFlag = false
      // 记录赠品行点击行为
      this.UPDATE_GIFT_OPT(1)
    },
    handleClose() {
      this.isShowPop = false
      // 更新用户最后一次主动选择行为下勾选的可选赠品，关闭弹窗就记录
      this.UPDATE_LAST_CHOOSED_GIFT_IDS()
      let arr = this.optionGifts.filter(v => v.canOptional == 1).map(v => v.optionalGiftId + v.id)
      // 更新当前skuId下勾选的可选赠品
      this.UPDATE_SELECTED_GIFT_IDS({
        skuId: this.skuId,
        ids: arr.length ? arr : []
      })
    }
  }
}
</script>
<style scoped lang="scss" src="./index.scss" />
<style lang="scss" scoped src="../../index/dark-popup.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4,
.vivo-fontscale-5 {
  .giveaway-item {
    width: 178px;
  }
  .giveaway .g-list {
    .g-name {
      height: 38px;
    }
    .g-top {
      padding: 0 6px 3px;
    }
  }
}
</style>
